module.exports = __webpack_public_path__ + "img/varilux-e-series.144e0555.svg";